import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card mb-30" }
const _hoisted_4 = { class: "card-body pb-0" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "ユーザー操作", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "メールアドレス", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " メールアドレスの形式が正しくありません。 ", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "姓", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "正しく入力してください。", -1)
const _hoisted_18 = { class: "col-md-6" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", null, "名", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "正しく入力してください。", -1)
const _hoisted_22 = {
  key: 0,
  class: "row"
}
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", null, "ロール", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = { class: "mx-2" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" ユーザー編集 ")
const _hoisted_29 = { class: "mx-2" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 経理 ")
const _hoisted_31 = {
  key: 1,
  class: "row"
}
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", null, "パスワード", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, " 正しくパスワードを入力してください。 ", -1)
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6 my-5 mx-auto" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.isReady)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", _hoisted_9, [
                        _hoisted_10,
                        (_ctx.userId <= 0)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "text",
                              class: _normalizeClass(["form-control border-input", { 'is-invalid': _ctx.invalidEmail }]),
                              placeholder: "メールアドレス",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user.userName) = $event))
                            }, null, 2)), [
                              [_vModelText, _ctx.user.userName]
                            ])
                          : (_openBlock(), _createElementBlock("h5", _hoisted_11, _toDisplayString(_ctx.user.userName), 1)),
                        _hoisted_12
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["form-control border-input", { 'is-invalid': _ctx.invalidLastName }]),
                          placeholder: "姓",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.user.lastName) = $event))
                        }, null, 2), [
                          [_vModelText, _ctx.user.lastName]
                        ]),
                        _hoisted_17
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: _normalizeClass(["form-control border-input", { 'is-invalid': _ctx.invalidFirstName }]),
                          placeholder: "名",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.user.firstName) = $event))
                        }, null, 2), [
                          [_vModelText, _ctx.user.firstName]
                        ]),
                        _hoisted_21
                      ])
                    ])
                  ]),
                  (!_ctx.isOwner)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _hoisted_26,
                            _createElementVNode("label", _hoisted_27, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.roleList.user) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.roleList.user]
                              ]),
                              _hoisted_28
                            ]),
                            _createElementVNode("label", _hoisted_29, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.roleList.finance) = $event))
                              }, null, 512), [
                                [_vModelCheckbox, _ctx.roleList.finance]
                              ]),
                              _hoisted_30
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.userId <= 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _hoisted_34,
                            _withDirectives(_createElementVNode("input", {
                              type: "password",
                              class: _normalizeClass(["form-control border-input", { 'is-invalid': _ctx.invalidPassword }]),
                              placeholder: "パスワード",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.password) = $event))
                            }, null, 2), [
                              [_vModelText, _ctx.user.password]
                            ]),
                            _hoisted_35
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _withDirectives(_createElementVNode("input", {
                              type: "password",
                              class: "form-control border-input",
                              placeholder: "パスワード確認",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.confirmPassword) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.confirmPassword]
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: _normalizeClass(["btn btn-info w-100 lodingBtn", { loding: _ctx.isLoading }]),
                          onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)), ["prevent"])),
                          disabled: _ctx.isLoading
                        }, " 保存 ", 10, _hoisted_40)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}